import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { fetchTarifExpressConfig } from "@/lib/api";

export const HotelManagerLinkButton = ({ hotel }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { fetchTarifExpressConfig().then(setCfg).catch(() => {}); }, []);
  if (!cfg?.support_whatsapp || !hotel) return null;
  const num = cfg.support_whatsapp.replace(/\D/g, "");
  const text = `Bonjour Fodindin, je suis le gerant de « ${hotel.name} » (${hotel.city || ""}, ref ${hotel.id}). Merci de m'envoyer mon lien Tarif Express pour ajuster mes prix du jour.`;
  return (
    <a
      href={`https://wa.me/${num}?text=${encodeURIComponent(text)}`}
      target="_blank"
      rel="noreferrer"
      className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline"
      data-testid="hotel-manager-link-btn"
    >
      <MessageCircle size={15} /> Vous gerez cet hotel ? Recevoir mon lien Tarif Express (WhatsApp)
    </a>
  );
};
